import React, { useMemo, useState, useEffect } from "react";
import {
  Grid,
  Autocomplete,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,

} from "@mui/material";
import {
  billList,

  getBillingsByBranch
} from "../../../Services/Services";

const BillSummaryTable = () => {
  const [billData, setBillData] = useState([]);
  const [partyData, setpartyData] = useState([]);

  const [filters, setFilters] = useState({
    branch: null,
    billId: null,
    freightId: null,
    party: null,
  });

  // Fetch billing data for dropdowns
  useEffect(() => {
    const fetchInitialData = async () => {
      const data = await billList();
      if (data) {
        setpartyData(data);
      }
    };
    fetchInitialData();
  }, []);

  const handlePartyChange = async (partyId) => {
    if (partyId) {
      const data = await getBillingsByBranch(partyId);
      setBillData(data);
    }
  };


  



  function formatOnlyDate(dateTimeString, format = "dd-mm-yyyy") {
    const date = new Date(dateTimeString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    if (format === "dd-mm-yyyy") return `${day}-${month}-${year}`;
    if (format === "yyyy-mm-dd") return `${year}-${month}-${day}`;
    throw new Error("Unsupported format.");
  }




  return (
    <>
      <Grid container spacing={2} mb={2}>
        <Grid item xs={12} sm={3}>
          <Autocomplete
            options={partyData}
            getOptionLabel={(option) => option?.branch_name || ""}
            onChange={(event, selectedOption) => {
              if (selectedOption) {
                handlePartyChange(selectedOption.branch_id);  // assuming `id` is party_id
              } else {
                setBillData([])
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Branch Name"
                variant="outlined"
                size="medium"
                required
                sx={{ "& .MuiInputBase-root": { height: "45px" } }}
              />
            )}
          />

        </Grid>
       
      </Grid>

      <TableContainer sx={{ overflowX: "auto", mt: 2 }}>
        <Table
          size="small"
          sx={{
            tableLayout: "auto",
            "& td, & th": {
              textAlign: "center",
              whiteSpace: "nowrap",
              padding: "0px 8px",
              fontSize: "0.8125rem",
              borderBottom: "1px solid #ccc",
            },
          }}
        >
          <TableHead
            sx={{
              "& th": {
                fontWeight: "bold",
                backgroundColor: "#f5f5f5",
              },
            }}
          >
            <TableRow>
              <TableCell>Sr. No.</TableCell>
              <TableCell>Bill ID</TableCell>
              <TableCell>Party Name</TableCell>
              <TableCell>Branch Name</TableCell>
              <TableCell>Bill Date</TableCell>
              <TableCell>Total Amount</TableCell>
              <TableCell>Received Amount</TableCell>
              <TableCell>Balance Amount</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {billData.length > 0 ? (
              billData.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                  }}
                >
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{row.billing_id}</TableCell>
                  <TableCell>{row.party_name}</TableCell>
                  <TableCell>{row.branch_name}</TableCell>
                  <TableCell>{formatOnlyDate(row.created_at)}</TableCell>
                  <TableCell>{(row.total_amount).toFixed(2)}</TableCell>
                  <TableCell>{(row.paid_amount).toFixed(2)}</TableCell>
                  <TableCell>{(row.rem_amount).toFixed(2)}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  No records found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
             <TableRow
                        sx={{
                          backgroundColor: "#e3f2fd",
                          fontWeight: "bold",
                        }}
          
                      >
                        <TableCell colSpan={5} align="right">
                          Total:
                        </TableCell>
                        <TableCell align="center">
                          {billData.reduce(
                            (accumulator, currentValue) =>
                              accumulator + (+currentValue.total_amount || 0),
                            0
                          ).toFixed(1)}
                        </TableCell>
                        <TableCell align="center">
                          {billData.reduce(
                            (accumulator, currentValue) =>
                              accumulator + (+currentValue.paid_amount || 0),
                            0
                          ).toFixed(1)}
                        </TableCell>
                        <TableCell align="center">
                          {billData.reduce(
                            (accumulator, currentValue) =>
                              accumulator + (+currentValue.rem_amount || 0),
                            0
                          ).toFixed(1)}
                        </TableCell>
          
          
                      </TableRow>
        </Table>
      </TableContainer>



    </>
  );
};

export default BillSummaryTable;
